(function () {
  'use strict';
  function initializeDrawer(header, mobile) {
    var drawer = mobile.querySelector('.wwh-mobile-drawer');
    var trigger = mobile.querySelector('.oc-menu-bar');
    if (!drawer || !trigger || typeof drawer.showModal !== 'function') return;
    var appTrigger = document.querySelector('#mobile-app-header #mobileHeader-hamburgerBtn');
    var triggers = appTrigger ? [trigger, appTrigger] : [trigger];
    var opener = trigger;
    triggers.forEach(function (button) {
      button.setAttribute('aria-haspopup', 'dialog');
      button.setAttribute('aria-controls', drawer.id);
      button.setAttribute('aria-expanded', 'false');
    });
    var closeButton = drawer.querySelector('.wwh-mobile-drawer__close');
    var breakpoint = window.matchMedia('(max-width: 1365px)');
    var reducedMotion = window.matchMedia('(prefers-reduced-motion: reduce)');
    var scrollState = null;
    var closeTimer = null;
    var pairs = [];
    // Keep the existing merchant menu; only its modal presentation moves.
    document.body.appendChild(drawer);
    var contactToggle = drawer.querySelector('.wwh-mobile-drawer__contact-toggle');
    var contactPanel = drawer.querySelector('.wwh-drawer-contact');
    var supportSource = header.querySelector('.contact-dropdown');
    if (contactToggle && contactPanel && supportSource) {
      // Reuse the desktop menu as the single source for destinations and content.
      // Copy only action attributes/icons, never status IDs or tooltip bindings.
      function appendContact(source, detail) {
        if (!source) return;
        var action = source.cloneNode(false);
        action.removeAttribute('style');
        action.removeAttribute('id');
        action.className = 'wwh-drawer-contact__row';
        var sourceLabel = source.querySelector('strong');
        var label = sourceLabel ? sourceLabel.textContent.trim() : source.textContent.trim();
        if (label === 'Call') label = 'Call Us';
        var sourceIcon = source.querySelector('img') || contactToggle.querySelector('.wwh-navigation-icon');
        if (sourceIcon) {
          var icon = sourceIcon.cloneNode(true);
          icon.removeAttribute('style');
          icon.setAttribute('aria-hidden', 'true');
          if (icon.tagName === 'IMG') icon.setAttribute('alt', '');
          action.appendChild(icon);
        }
        var copy = document.createElement('span');
        var title = document.createElement('strong');
        title.textContent = label;
        copy.appendChild(title);
        if (detail) {
          var secondary = document.createElement('small');
          secondary.textContent = detail;
          copy.appendChild(secondary);
        }
        action.appendChild(copy);
        contactPanel.appendChild(action);
      }
      var phone = supportSource.querySelector('a[href^="tel:"]');
      var phoneNumber = phone && phone.querySelector('strong + span');
      appendContact(phone, phoneNumber ? phoneNumber.textContent.trim() : '');
      var email = supportSource.querySelector('a[href^="mailto:"]');
      appendContact(email, email ? email.getAttribute('href').slice(7).split('?')[0] : '');
      appendContact(supportSource.querySelector('a[onclick*="Formilla.initFormillaChat"]'));
      appendContact(supportSource.querySelector('a[href="/pages/contact-us"]'));
      var hours = supportSource.querySelector('.wwh-header-support-hours');
      if (hours) {
        var hoursCopy = document.createElement('p');
        hoursCopy.className = 'wwh-drawer-contact__hours';
        hoursCopy.textContent = hours.textContent.trim();
        contactPanel.appendChild(hoursCopy);
      }
      var socials = document.createElement('div');
      socials.className = 'wwh-drawer-contact__social';
      supportSource.querySelectorAll('.wwh-header-social a.fa-facebook, .wwh-header-social a.fa-instagram, .wwh-header-social a.fa-linkedin').forEach(function (source) {
        var social = source.cloneNode(true);
        var network = source.classList.contains('fa-facebook') ? 'Facebook' : source.classList.contains('fa-instagram') ? 'Instagram' : 'LinkedIn';
        social.setAttribute('aria-label', source.getAttribute('aria-label') || source.getAttribute('title') || source.getAttribute('data-original-title') || network);
        ['id', 'title', 'data-toggle', 'data-placement', 'data-original-title', 'aria-describedby'].forEach(function (attribute) { social.removeAttribute(attribute); });
        socials.appendChild(social);
      });
      if (socials.children.length) contactPanel.appendChild(socials);
    }
    function resetContact() {
      if (contactPanel) contactPanel.hidden = true;
      if (contactToggle) contactToggle.setAttribute('aria-expanded', 'false');
    }
    drawer.querySelectorAll('button.a-click-show').forEach(function (button, index) {
      var panel = button.nextElementSibling;
      if (!panel) return;
      panel.id = panel.id || drawer.id + '-submenu-' + index;
      panel.hidden = true;
      button.setAttribute('aria-controls', panel.id);
      button.setAttribute('aria-expanded', 'false');
      var link = button.previousElementSibling;
      if (link) button.setAttribute('aria-label', 'Toggle ' + link.textContent.trim() + ' submenu');
      pairs.push({ button: button, panel: panel });
    });
    function setExpanded(pair, expanded) {
      pair.button.setAttribute('aria-expanded', String(expanded));
      pair.panel.hidden = !expanded;
      pair.button.parentElement.classList.toggle('expand', expanded);
      if (!expanded) pairs.forEach(function (child) {
        if (pair.panel.contains(child.button)) {
          child.button.setAttribute('aria-expanded', 'false');
          child.panel.hidden = true;
          child.button.parentElement.classList.remove('expand');
        }
      });
    }
    function unlock() {
      if (!scrollState) return;
      var saved = scrollState;
      scrollState = null;
      saved.styles.forEach(function (style) {
        if (style.value) document.body.style.setProperty(style.name, style.value, style.priority);
        else document.body.style.removeProperty(style.name);
      });
      var root = document.documentElement;
      var behavior = root.style.getPropertyValue('scroll-behavior');
      var priority = root.style.getPropertyPriority('scroll-behavior');
      root.style.setProperty('scroll-behavior', 'auto', 'important');
      window.scrollTo(saved.x, saved.y);
      if (behavior) root.style.setProperty('scroll-behavior', behavior, priority);
      else root.style.removeProperty('scroll-behavior');
    }
    function finishClose() {
      clearTimeout(closeTimer);
      closeTimer = null;
      resetContact();
      if (drawer.open) drawer.close();
      drawer.classList.remove('is-closing');
      triggers.forEach(function (button) { button.setAttribute('aria-expanded', 'false'); });
      if (opener.getClientRects().length) opener.focus({ preventScroll: true });
      unlock();
    }
    function close(immediate) {
      if (!drawer.open || closeTimer) return;
      if (immediate || reducedMotion.matches) finishClose();
      else {
        drawer.classList.add('is-closing');
        closeTimer = setTimeout(finishClose, 200);
      }
    }
    function open(button) {
      if (!breakpoint.matches || drawer.open) return;
      opener = button;
      drawer.classList.toggle('wwh-mobile-drawer--app', opener === appTrigger);
      // Dismiss only header popups; no third-party modal or app state is changed.
      var cart = header.querySelector('#cart.open');
      if (cart) {
        var cartButton = cart.querySelector(':scope > button');
        // Use Bootstrap's existing close behavior, including its touch backdrop.
        if (cartButton) cartButton.click();
      }
      var support = header.querySelector('.contact-dropdown');
      if (support) support.style.display = 'none';
      var supportButton = header.querySelector('.contact-support-toggle');
      if (supportButton) supportButton.setAttribute('aria-expanded', 'false');
      var names = ['position', 'top', 'left', 'width'];
      scrollState = {
        x: window.scrollX, y: window.scrollY,
        styles: names.map(function (name) {
          return { name: name, value: document.body.style.getPropertyValue(name), priority: document.body.style.getPropertyPriority(name) };
        })
      };
      var width = document.documentElement.clientWidth;
      document.body.style.setProperty('position', 'fixed', 'important');
      document.body.style.setProperty('top', -scrollState.y + 'px', 'important');
      document.body.style.setProperty('left', -scrollState.x + 'px', 'important');
      document.body.style.setProperty('width', width + 'px', 'important');
      drawer.showModal();
      triggers.forEach(function (button) { button.setAttribute('aria-expanded', 'true'); });
      closeButton.focus({ preventScroll: true });
    }
    // Capture stops legacy menu.js toggles before they can expand the old block.
    // The Canvas app header opens this same dialog, never a second menu.
    triggers.forEach(function (button) {
      button.addEventListener('click', function (event) {
        event.preventDefault();
        event.stopImmediatePropagation();
        open(button);
      }, true);
    });
    drawer.addEventListener('click', function (event) {
      if (event.target.closest('.wwh-mobile-drawer__contact-toggle')) {
        event.preventDefault();
        event.stopImmediatePropagation();
        contactPanel.hidden = !contactPanel.hidden;
        contactToggle.setAttribute('aria-expanded', String(!contactPanel.hidden));
        return;
      }
      var disclosure = event.target.closest('button.a-click-show');
      if (disclosure) {
        event.preventDefault();
        event.stopImmediatePropagation();
        var pair = pairs.find(function (entry) { return entry.button === disclosure; });
        if (!pair) return;
        var expanding = pair.panel.hidden;
        // Match the legacy accordion: one sibling submenu open at each level.
        if (expanding) pairs.forEach(function (entry) {
          if (entry !== pair && entry.button.parentElement.parentElement === disclosure.parentElement.parentElement) setExpanded(entry, false);
        });
        setExpanded(pair, expanding);
      } else if (event.target.closest('.wwh-mobile-drawer__close')) close(false);
      else if (event.target === drawer) {
        var rect = drawer.getBoundingClientRect();
        if (event.clientX < rect.left || event.clientX >= rect.right || event.clientY < rect.top || event.clientY >= rect.bottom) close(false);
      } else if (event.target.closest('a[href]')) {
        var link = event.target.closest('a[href]');
        if (link.getAttribute('href') === '#') {
          event.preventDefault();
          var button = link.parentElement.querySelector(':scope > button.a-click-show');
          if (button) button.click();
        } else close(true);
      }
    }, true);
    drawer.addEventListener('cancel', function (event) { event.preventDefault(); close(false); });
    drawer.addEventListener('close', function () {
      if (drawer.open) return;
      resetContact();
      triggers.forEach(function (button) { button.setAttribute('aria-expanded', 'false'); });
      unlock();
    });
    drawer.addEventListener('keydown', function (event) {
      if (event.key !== 'Tab') return;
      var focusable = Array.from(drawer.querySelectorAll('a[href], button:not([disabled]), [tabindex="0"]')).filter(function (element) { return element.getClientRects().length > 0; });
      var first = focusable[0], last = focusable[focusable.length - 1];
      if (event.shiftKey && document.activeElement === first) { event.preventDefault(); last.focus(); }
      else if (!event.shiftKey && document.activeElement === last) { event.preventDefault(); first.focus(); }
    });
    breakpoint.addEventListener('change', function () { if (!breakpoint.matches) close(true); });
    window.addEventListener('pagehide', function () { close(true); });
    var onUnload = function (event) {
      if (!event.target.contains(header)) return;
      close(true);
      drawer.remove();
      document.removeEventListener('shopify:section:unload', onUnload);
    };
    document.addEventListener('shopify:section:unload', onUnload);
  }
  function initialize() {
    var header = document.querySelector('#shopify-section-header .wwh-header');
    if (!header || header.dataset.wwhAccessible) return;
    header.dataset.wwhAccessible = 'true';
    var cart = header.querySelector('#cart');
    if (cart) {
      var cartTrigger = cart.querySelector(':scope > button');
      var cartPopup = cart.querySelector(':scope > .dropdown-menu');
      if (cartTrigger && cartPopup) {
        var cartLabel = cartTrigger.querySelector('.mycart > span');
        cartTrigger.setAttribute('aria-label', cartLabel ? cartLabel.textContent.trim() : 'My Cart');
        cartPopup.id = cartPopup.id || 'wwh-header-cart-popup';
        cartTrigger.setAttribute('aria-controls', cartPopup.id);
        var syncCart = function () {
          cartTrigger.setAttribute('aria-expanded', String(cart.classList.contains('open')));
          cart.querySelectorAll('.samitaWS-clone-checkout-button:not([href])').forEach(function (button) {
            if (!button.hasAttribute('role')) button.setAttribute('role', 'button');
            if (!button.hasAttribute('tabindex')) button.setAttribute('tabindex', '0');
          });
        };
        syncCart();
        new MutationObserver(syncCart).observe(cart, { subtree: true, childList: true, attributes: true, attributeFilter: ['class'] });
        cart.addEventListener('keydown', function (event) {
          var checkout = event.target.closest('.samitaWS-clone-checkout-button:not([href])');
          if (checkout && (event.key === 'Enter' || event.key === ' ')) {
            event.preventDefault();
            event.stopPropagation();
            checkout.click();
          }
        });
      }
    }
    var mobile = header.querySelector('#oc-menu-mheader');
    if (mobile && mobile.querySelector('.wwh-mobile-drawer')) initializeDrawer(header, mobile);
    else if (mobile) {
      var bar = mobile.querySelector('.oc-menu-bar');
      var list = mobile.querySelector('.ul-top-items');
      list.id = list.id || 'wwh-mobile-navigation';
      bar.setAttribute('aria-controls', list.id);
      var pairs = [[bar, list]];
      mobile.querySelectorAll('button.a-click-show').forEach(function (button, index) {
        var panel = button.nextElementSibling;
        if (!panel) return;
        panel.id = panel.id || 'wwh-mobile-submenu-' + index;
        button.setAttribute('aria-controls', panel.id);
        pairs.push([button, panel]);
      });
      var syncMobile = function () {
        pairs.forEach(function (pair) { pair[0].setAttribute('aria-expanded', String(pair[1].getClientRects().length > 0)); });
      };
      syncMobile();
      new MutationObserver(syncMobile).observe(mobile, { subtree: true, attributes: true, attributeFilter: ['style', 'class'] });
      mobile.addEventListener('keydown', function (event) {
        if (event.key === 'Escape' && list.getClientRects().length) {
          event.preventDefault();
          bar.click();
          bar.focus();
        }
      });
    }
    var desktop = header.querySelector('#oc-menu-header');
    if (desktop) {
      var items = [];
      desktop.querySelectorAll('.li-top-item, .li-second-items').forEach(function (item, index) {
        var panel = item.querySelector(':scope > .sub-menu-container, :scope > .flyout-third-items');
        var link = item.querySelector(':scope > .a-top-link, :scope > .a-second-link');
        if (!panel || !link) return;
        panel.id = panel.id || 'wwh-desktop-submenu-' + index;
        link.setAttribute('aria-controls', panel.id);
        link.setAttribute('aria-haspopup', 'true');
        items.push([item, link, panel]);
        item.addEventListener('mouseenter', function () { item.classList.remove('wwh-menu-dismissed'); });
        item.addEventListener('focusout', function () {
          requestAnimationFrame(function () { if (!item.contains(document.activeElement)) item.classList.remove('wwh-menu-dismissed'); });
        });
        item.addEventListener('keydown', function (event) {
          if (event.key === 'Escape') {
            event.preventDefault();
            event.stopPropagation();
            item.classList.add('wwh-menu-dismissed');
            panel.style.display = 'none';
            link.focus();
          } else if (event.key === 'ArrowDown' && event.target === link) {
            event.preventDefault();
            item.classList.remove('wwh-menu-dismissed');
            var first = panel.querySelector('a[href], button');
            if (first) first.focus();
          }
        });
      });
      var syncDesktop = function () { items.forEach(function (pair) { pair[1].setAttribute('aria-expanded', String(pair[2].getClientRects().length > 0)); }); };
      desktop.addEventListener('focusin', syncDesktop);
      desktop.addEventListener('focusout', function () { requestAnimationFrame(syncDesktop); });
      new MutationObserver(syncDesktop).observe(desktop, { subtree: true, attributes: true, attributeFilter: ['style', 'class'] });
      syncDesktop();
    }
    header.addEventListener('keydown', function (event) {
      var support = header.querySelector('.contact-dropdown');
      if (event.key === 'Escape' && support && support.style.display === 'block') {
        event.preventDefault();
        support.style.display = 'none';
        var toggle = header.querySelector('.contact-support-toggle');
        toggle.setAttribute('aria-expanded', 'false');
        toggle.focus();
      }
    });
  }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', initialize);
  else initialize();
  document.addEventListener('shopify:section:load', initialize);
})();

(function () {
  'use strict';
  function initializeAccount() {
    var header = document.querySelector('#shopify-section-header .wwh-header');
    var account = header && header.querySelector('[data-wwh-account]');
    if (!account || account.dataset.wwhAccountReady) return;
    account.dataset.wwhAccountReady = 'true';
    var disclosure = account.querySelector('details');
    var trigger = disclosure.querySelector('summary');
    var links = disclosure.querySelector('.wwh-header-account-links');
    var search = header.querySelector('.top-search');
    var input = header.querySelector('#text-search');
    var searchButton = header.querySelector('#sp-btn-search');
    var frame = null;
    var canvas = document.createElement('canvas').getContext('2d');

    function isInline() { return account.classList.contains('wwh-account--inline'); }
    function sync() { trigger.setAttribute('aria-expanded', String(!isInline() && disclosure.open)); }
    function close(restoreFocus) {
      if (isInline() || !disclosure.open) return;
      disclosure.open = false;
      sync();
      if (restoreFocus) trigger.focus({ preventScroll: true });
    }
    function fit() {
      frame = null;
      if (!account.isConnected || !account.getClientRects().length) return;
      if (account.dataset.customer === 'true' || !search || !input) { sync(); return; }
      var wasInline = isInline();
      var active = document.activeElement;
      var keepOpen = (!wasInline && disclosure.open) || links.contains(active);
      // Measure the real inline layout before painting, using the same links.
      account.classList.add('wwh-account--inline');
      disclosure.open = true;
      var fieldStyle = getComputedStyle(input);
      canvas.font = fieldStyle.font;
      var desiredSearch = canvas.measureText(input.placeholder).width
        + parseFloat(fieldStyle.paddingLeft) + parseFloat(fieldStyle.paddingRight)
        + (searchButton ? searchButton.getBoundingClientRect().width : 0) + 2;
      var searchRect = search.getBoundingClientRect();
      var accountRect = account.getBoundingClientRect();
      var sameRow = Math.abs(searchRect.y + searchRect.height / 2 - accountRect.y - accountRect.height / 2) < 2;
      var inline = sameRow && searchRect.width >= desiredSearch;
      account.classList.toggle('wwh-account--inline', inline);
      disclosure.open = inline || keepOpen;
      sync();
      if (active === trigger) {
        (inline ? links.querySelector('a') : trigger).focus({ preventScroll: true });
      }
    }
    function schedule() { if (frame === null) frame = requestAnimationFrame(fit); }
    disclosure.addEventListener('toggle', sync);
    account.addEventListener('keydown', function (event) {
      if (event.key === 'Escape' && !isInline() && disclosure.open) {
        event.preventDefault(); event.stopPropagation(); close(true);
      } else if (event.target === trigger && (event.key === 'ArrowDown' || event.key === 'ArrowUp')) {
        event.preventDefault(); disclosure.open = true; sync();
        var items = links.querySelectorAll('a');
        items[event.key === 'ArrowUp' ? items.length - 1 : 0].focus();
      }
    });
    function outside(event) { if (!account.contains(event.target)) close(false); }
    document.addEventListener('pointerdown', outside);
    var navigation = header.querySelector('.wwh-desktop-nav');
    function leaveForNavigation() { close(false); }
    if (navigation) navigation.addEventListener('pointerenter', leaveForNavigation);
    account.addEventListener('focusout', function () {
      requestAnimationFrame(function () { if (!account.contains(document.activeElement)) close(false); });
    });
    var resize = new ResizeObserver(schedule);
    resize.observe(header.querySelector('.header-inner > .container > .container-inner'));
    resize.observe(account);
    if (search) resize.observe(search);
    var mutations = new MutationObserver(schedule);
    mutations.observe(account, { childList: true, characterData: true, subtree: true });
    if (input) mutations.observe(input, { attributes: true, attributeFilter: ['placeholder'] });
    window.addEventListener('resize', schedule);
    if (document.fonts) document.fonts.ready.then(schedule);
    function unload(event) {
      if (!event.target.contains(account)) return;
      resize.disconnect(); mutations.disconnect();
      document.removeEventListener('pointerdown', outside);
      if (navigation) navigation.removeEventListener('pointerenter', leaveForNavigation);
      window.removeEventListener('resize', schedule);
      document.removeEventListener('shopify:section:unload', unload);
      if (frame !== null) cancelAnimationFrame(frame);
    }
    document.addEventListener('shopify:section:unload', unload);
    schedule();
  }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', initializeAccount);
  else initializeAccount();
  document.addEventListener('shopify:section:load', initializeAccount);
})();

(function () {
  function initializeReplacementCopy() {
    var cta = document.querySelector('#shopify-section-header .wwh-header .wwh-replacement-finder-cta');
    var copy = cta && cta.querySelector('.wwh-replacement-finder-copy');
    if (!copy || cta.dataset.wwhTextFit) return;
    cta.dataset.wwhTextFit = 'true';
    var frame = null;
    function fit() {
      frame = null;
      if (!cta.isConnected || !cta.getClientRects().length) return;
      var style = getComputedStyle(cta);
      var normalHeight = parseFloat(style.getPropertyValue('--wwh-finder-cta-height'));
      var extra = ['paddingTop', 'paddingBottom', 'borderTopWidth', 'borderBottomWidth'].reduce(function (total, property) { return total + parseFloat(style[property]); }, 0);
      if (normalHeight) cta.classList.toggle('wwh-copy-wrap', copy.getBoundingClientRect().height + extra > normalHeight + 2);
    }
    function schedule() { if (frame === null) frame = requestAnimationFrame(fit); }
    var mutations = new MutationObserver(schedule);
    mutations.observe(copy, { childList: true, characterData: true, subtree: true });
    var resize = new ResizeObserver(schedule);
    resize.observe(copy);
    resize.observe(cta);
    function unload(event) {
      if (!event.target.contains(cta)) return;
      mutations.disconnect();
      resize.disconnect();
      if (frame !== null) cancelAnimationFrame(frame);
      document.removeEventListener('shopify:section:unload', unload);
    }
    document.addEventListener('shopify:section:unload', unload);
    schedule();
  }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', initializeReplacementCopy);
  else initializeReplacementCopy();
  document.addEventListener('shopify:section:load', initializeReplacementCopy);
})();
